import { useEffect, useState } from "react";
import { debounce } from "lodash-es";
//#region src/hooks/useWindowSize.ts
function useWindowSize(opts = { debounceMs: 250 }) {
	const [windowSize, setWindowSize] = useState({
		height: window.innerHeight,
		width: window.innerWidth
	});
	useEffect(() => {
		const handleResize = debounce(function() {
			setWindowSize({
				height: window.innerHeight,
				width: window.innerWidth
			});
		}, opts.debounceMs || 50);
		window?.addEventListener("resize", handleResize);
		handleResize();
		return () => window?.removeEventListener("resize", handleResize);
	}, []);
	return windowSize;
}
//#endregion
export { useWindowSize };

//# sourceMappingURL=useWindowSize.js.map